








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StepNumber extends Vue {
  @Prop(String) private number!: string;
  @Prop({ type: Boolean, default: false }) private isActive!: boolean;
  @Prop({ type: Boolean, default: false }) private isDone!: boolean;
}
